import { theme } from '@mti/multitenant-ui-shared';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as OriginalThemeProvider } from '@mui/material/styles';
import {
  selectTheme,
  selectUserProfile,
} from 'app/containers/AuthProvider/selectors';
import { actions as authActions } from 'app/containers/AuthProvider/slice';
import { reducer, sliceKey } from 'app/containers/Header/slice';
import React, { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'redux-injectors';

export const ThemeProvider = (props: PropsWithChildren<{}>) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  const currentThemeMode = useSelector(selectTheme);
  const userProfile = useSelector(selectUserProfile);
  const dispatch = useDispatch();
  const memoizedTheme = React.useMemo(
    () => theme(currentThemeMode),
    [currentThemeMode],
  );

  useEffect(() => {
    dispatch(
      authActions.updateUserPreferences({
        tenantId: userProfile.tenantId,
        accessToken: userProfile.accessToken,
        operatorEmail: userProfile.email,
        userPreferences: {
          themeMode: currentThemeMode,
        },
      }),
    );
  }, [currentThemeMode, dispatch, userProfile]);

  return (
    <OriginalThemeProvider theme={memoizedTheme}>
      <CssBaseline />
      {React.Children.only(props.children)}
    </OriginalThemeProvider>
  );
};
